import { shallowRef } from 'vue'
import { createWebSocketTransport } from './websocket/transport'
import { useWorkflow } from '@/composables/workflow/useWorkflow'
import type { SessionContext, SessionStrategy } from './types'

export const createWidgetSession = () => {
    const transport = createWebSocketTransport()

    const strategy = shallowRef<SessionStrategy | undefined>()

    return {
        transport,
        get strategy() {
            return strategy.value
        },
        setStrategy(value: SessionStrategy | undefined) {
            strategy.value = value
        },
    }
}

export type WidgetSession = ReturnType<typeof createWidgetSession>

const session = createWidgetSession()

const useWidgetSession = () => session

export const useSessionContext = (): SessionContext => {
    const { token, decodedToken, mode } = useWorkflow()

    return {
        token: token.value as string,
        decoded: decodedToken.value as SessionContext['decoded'],
        mode: mode.value,
    }
}

export default useWidgetSession
